import type { RouteRecordRaw } from 'vue-router'
import LayoutApp from '@/views/app/the-layout.vue'
import LayoutAuth from '@/views/auth/the-layout.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/app',
    component: LayoutApp,
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/app/home/the-page.vue'),
        // redirect: { name: 'invoice' },
        meta: { title: 'Home' },
      },
    ],
  },

  {
    path: '/karyawan',
    component: LayoutApp,
    children: [
      {
        path: '',
        name: 'employee list',
        component: () => import('@/views/app/employee/the-page.vue'),
        meta: { title: 'Daftar Karyawan' },
      },
    ],
  },

  {
    path: '/absensi',
    component: LayoutApp,
    children: [
      {
        path: '',
        name: 'attendance create',
        component: () => import('@/views/app/attendance/create/the-page.vue'),
        meta: { title: 'Absensi' },
      },
      {
        path: ':range(mingguan|bulanan)',
        name: 'attendance report select range',
        component: () => import('@/views/app/attendance/report/select-range/the-page.vue'),
        meta: { title: 'Laporan Absensi' },
      },
      {
        path: 'mingguan/:date',
        name: 'attendance report weekly detail',
        component: () => import('@/views/app/attendance/report/summary-weekly/the-page.vue'),
        meta: { title: 'Laporan Absensi Mingguan' },
      },
      {
        path: 'bulanan/:date',
        name: 'attendance report monthly detail',
        component: () => import('@/views/app/attendance/report/summary-monthly/the-page.vue'),
        meta: { title: 'Laporan Absensi Bulanan' },
      },
    ],
  },

  {
    path: '/item',
    component: LayoutApp,
    children: [
      {
        path: '',
        name: 'item list',
        component: () => import('@/views/app/item/list/the-page.vue'),
        meta: { title: 'Daftar Item' },
      },
    ],
  },

  {
    path: '/customer',
    component: LayoutApp,
    children: [
      {
        path: '',
        name: 'customer list',
        component: () => import('@/views/app/customer/list/the-page.vue'),
        meta: { title: 'Daftar Customer' },
      },
      {
        path: ':id',
        name: 'customer detail',
        component: () => import('@/views/app/item/list/the-page.vue'),
        meta: { title: 'Detail Customer' },
      },
    ],
  },

  {
    path: '/invoice',
    component: LayoutApp,
    children: [
      // join 3 routes into 1 route for menu bar active route
      // {
      //   path: ':id(baru|\\d+)?/:action(edit)?',
      //   name: 'invoice',
      //   component: () => import('@/views/app/sales-invoice/the-page.vue'),
      //   meta: { title: 'Invoice' },
      // },
      {
        path: '',
        name: 'invoice',
        component: () => import('@/views/app/sales-invoice/the-page.vue'),
        meta: { title: 'Invoice' },
      },
      {
        path: 'baru',
        name: 'invoice create',
        component: () => import('@/views/app/sales-invoice/the-page.vue'),
        meta: { title: 'Invoice' },
      },
      {
        path: ':id(\\d+)',
        name: 'invoice detail',
        component: () => import('@/views/app/sales-invoice/the-page.vue'),
        meta: { title: 'Invoice' },
      },
      {
        path: ':id(\\d+)/edit',
        name: 'invoice edit',
        component: () => import('@/views/app/sales-invoice/the-page.vue'),
        meta: { title: 'Invoice' },
      },
    ],
  },

  {
    path: '/kendaraan',
    component: LayoutApp,
    children: [
      {
        path: '',
        name: 'vehicle list',
        component: () => import('@/views/app/vehicle/usage/the-page.vue'),
        meta: { title: 'Daftar Kendaraan' },
      },
    ],
  },

  {
    path: '/auth',
    component: LayoutAuth,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/auth/login/the-page.vue'),
        meta: { title: 'Masuk' },
      },
    ],
  },
]

export default routes
